/* eslint-disable no-underscore-dangle */

/** Utils for interacting with data layer objects */
export default class TrackingUtil {
  /** wrapper around window._mfq.push() */
  public static mouseFlowPush(toPush: (string | boolean)[]): void {
    window._mfq = window._mfq || [];
    // eslint-disable-next-line no-console
    console.log('mouseFlowPush', toPush);
    window._mfq.push(toPush);
  }

  /** safely wrappers around window.dataLayer */
  public static dataLayerPush(data: GoogleAnalyticsEventObject) {
    try {
      // getting strange build errors for window.ptcDebug
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const win: any = window || {};
      win.ptcDebug = win.ptcDebug || {};
      win.ptcDebug.dataLayerPushes = win.ptcDebug.dataLayerPushes || [];
      win.ptcDebug.dataLayerPushes.push(data);
    } catch (e) { /** ignore */ }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
}
